import { FC } from 'react'
import PartnerLogos from '../Partnerlogos'
import { AwardsModulePartnerLogos } from '../../../types/components'

const ModulePartnerlogos: FC<{
  moduleProps: AwardsModulePartnerLogos['attributes']
}> = ({ moduleProps }) => {
  return (
    <PartnerLogos
      moduleProps={moduleProps}
    />
  )
}

export default ModulePartnerlogos
